export default "__VITE_ASSET__11586532__"